// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/open-link.svg", import.meta.url);
// Module
var code = `<div class="container">
  <div class="head">
    <div class="title">\${this.title ?? ''}</div>
    <div class="footer">
      <div class="footer-link hide">\${this.link ?? ''}</div>
      <div class="footer-icon hide"><img src="${___HTML_LOADER_IMPORT_0___}" class="open-link" alt="open-link"></div>
    </div>
  </div>
</div>
`;
// Exports
export default code;